import service from "@/store/services/address-service";

const state = {
  list: {},
  address: false
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_ADDRESS: (state, address) => {
    state.address = address;
  }
};

const actions = {
  create({ rootGetters }, params) {
    return service
      .create(params, rootGetters["address/address"])
      .then(({ address }) => {
        return Promise.resolve(address);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  read({ commit }, params) {
    return service
      .read(params)
      .then(({ addresses }) => {
        commit("SET_LIST", addresses);
        return Promise.resolve(addresses);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  update({ _ }, params) {
    return service
      .update(params)
      .then(({ address }) => {
        return Promise.resolve(address);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  orderUpdate({ _ }, params) {
    return service
      .orderUpdate(params)
      .then(({ address }) => {
        return Promise.resolve(address);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  destroy({ _ }, id) {
    return service
      .destroy(id)
      .then(({ data_name }) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  },
  getCities({ _ }, params) {
    return service
      .getCities(params)
      .then(({ cities }) => {
        return Promise.resolve(cities);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  getStates({ _ }) {
    return service
      .getStates()
      .then(({ states }) => {
        return Promise.resolve(states);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  setAddress({ commit }, address) {
    commit("SET_ADDRESS", address);
  }
};

const getters = {
  list: (state) => state.list,
  address: (state) => state.address,
};

const address = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default address;
